import React, { useEffect, useState } from 'react';

// import Create from '../pages/Create';
// import Library from '../pages/Library';
import Reader from '../pages/Reader';
// import Store from '../pages/Store';

export const bookRegex = /^\/books\/[a-zA-Z0-9]{20}/;

export enum ModalPage {
  SIGN_IN,
  TABLE_OF_CONTENTS,
}

export enum Page {
  CREATE,
  LIBRARY,
  READER,
  SEARCH,
  STORE,
}

// export const pageToComponent = {
//   [Page.READER]: Reader,
// };

const pageUrls = [
  // { page: Page.CREATE, path: '/create' },
  // { page: Page.LIBRARY, path: '/library' },
  { page: Page.READER, match: bookRegex },
  // { page: Page.STORE, path: '/store' },
];

export const PageContext = React.createContext<{
  modal?: ModalPage;
  page: Page;
  setModal: (modal?: ModalPage) => void;
  setPage: (page: Page) => void;
}>({ page: Page.STORE, setModal: () => {}, setPage: () => {} });

export function PageProvider({ children }: { children: JSX.Element }): JSX.Element | null {
  const [modal, setModal] = useState<ModalPage>();
  const [page, setPage] = useState<Page>(Page.READER);

  // useEffect(() => {
  //   const match = pageUrls.find(
  //     (pair) => pair.path === location.pathname || pair.match?.test(location.pathname),
  //   );
  //   setPage(match?.page ?? Page.STORE);
  // }, []);

  const handleSetPage = (page: Page): void => {
    setModal(undefined);
    setPage(page);
    const match = pageUrls.find((pair) => pair.page === page);
    if (match) window.history.pushState({}, '', match.path);
  };

  if (!page) return null;

  return (
    <PageContext.Provider value={{ modal, page, setModal, setPage: handleSetPage }}>
      {children}
    </PageContext.Provider>
  );
}
